import React, { ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../../../public/icons-v1_1";

// 섹션 안 입력 컨트롤 공통 스타일 — 상/하단 이미지 필드를 제외한 모든 입력의 높이를 32px로 맞춘다.
// 모달과 섹션 본문 컴포넌트가 함께 쓰므로 셸과 같은 자리에 둔다(모달에 두면 순환 import가 된다).
export const PATH_PICK_BUYER_INFO_INPUT_STYLE_PROPS = {
  fontSize: "13px",
  height: "32px",
  border: "0.5px solid #D4D4D1",
  borderRadius: "8px",
  background: "#FCFCFB",
  _placeholder: { color: "#8F8F8C" },
};

interface Props {
  icon: AssetTypes;
  title: string;
  description?: string;
  // 우상단 영역 — 안내 링크나 상태 배지를 넣는다
  action?: ReactNode;
  children: ReactNode;
}

// 판매자 기본 정보 설정 모달의 섹션 카드 셸.
// 6개 섹션이 아이콘 + 제목 + 설명 + 우상단 액션이라는 같은 골격을 반복하므로 여기로 모았다.
// 헤더 영역과 컨텐츠 영역은 배경색과 구분선으로 분리한다.
function PathPickBasketBuyerInfoSection({
  icon,
  title,
  description,
  action,
  children,
}: Props) {
  return (
    <Flex
      flexDirection={"column"}
      border={"0.5px solid #D4D4D1"}
      borderRadius={"8px"}
      // 헤더 배경이 둥근 모서리 밖으로 새지 않도록 잘라낸다.
      overflow={"hidden"}
      background={"#FFFFFF"}
    >
      {/* 액션은 제목 줄 오른쪽에만 두고, 설명은 그 아래 줄을 전체 폭으로 쓴다.
          설명까지 액션과 같은 줄에 두면 설명이 왼쪽 칸에 갇혀 좁은 폭에서 세로로 길어진다. */}
      <Flex
        flexDirection={"column"}
        gap={"2px"}
        padding={"12px 16px"}
        background={"#F7F9FA"}
        borderBottom={"0.5px solid #D4D4D1"}
      >
        <Flex
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"8px"}
        >
          <Flex gap={"6px"} alignItems={"center"}>
            <CustomIcon src={icon} width={16} height={16} color={"#1272EF"} />
            <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
              {title}
            </Text>
          </Flex>
          {action}
        </Flex>
        {description && (
          <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
            {description}
          </Text>
        )}
      </Flex>
      <Flex flexDirection={"column"} gap={"12px"} padding={"16px"}>
        {children}
      </Flex>
    </Flex>
  );
}

// 섹션 우상단의 안내 링크.
// circle_help 아이콘은 회색(#8F8F8C)이 하드코딩돼 있어 색이 안 바뀌므로 hover는 밑줄로 표현한다.
export function PathPickBasketBuyerInfoSectionGuideLink({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Flex
      gap={"4px"}
      alignItems={"center"}
      flexShrink={0}
      cursor={"pointer"}
      color={"#444440"}
      _hover={{ textDecoration: "underline" }}
      onClick={onClick}
    >
      <CustomIcon src={"circle_help"} width={16} height={16} />
      <Text textStyle={"body-sm-medium"}>{label}</Text>
    </Flex>
  );
}

export default PathPickBasketBuyerInfoSection;
